const CRORE = 1_00_00_000;
const LAKH = 1_00_000;
const LAKHS_THRESHOLD = 10 * LAKH;

function groupIndianDigits(n: number): string {
  const s = String(n);
  if (s.length <= 3) return s;
  const head = s.slice(0, -3);
  const tail = s.slice(-3);
  return head.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + tail;
}

export function formatInr(amount: number): string {
  if (amount < 0) return "−" + formatInr(-amount);

  if (amount >= CRORE) {
    const cr = amount / CRORE;
    const trimmed = Number(cr.toFixed(1));
    return `₹${trimmed % 1 === 0 ? trimmed.toFixed(0) : trimmed}Cr`;
  }

  if (amount >= LAKHS_THRESHOLD) {
    const lk = amount / LAKH;
    const trimmed = Number(lk.toFixed(1));
    return `₹${trimmed % 1 === 0 ? trimmed.toFixed(0) : trimmed}L`;
  }

  return `₹${groupIndianDigits(Math.round(amount))}`;
}
